import { ModalProps } from '@lwt-helix/modal';

export const defaultError: ModalProps = {
    title: 'An error has occurred',
    message:
        'Please refresh the page and try again.' +
        ' If you continue to have problems please contact customer support at 1-800-668-8768'
};

const errors: { [errorCode: number]: ModalProps } = {
    0: defaultError,
    400: { message: 'Bad Request' },
    401: { message: 'Unauthorized' },
    403: { message: 'User is Forbidden' },
    404: { message: 'Account not found' },
    409: { message: 'An account with this email address already exists' },
    500: { message: 'Internal Server Error' }
};

export default errors;
